export const DeviceViewEvent = {
  DEVICE_DATA_RECEIVED: 'deviceDataReceived',
  HIGH_USAGE_DATA_RECEIVED: 'highUsageDataReceived'
}
